<template>
  <div>
    <div style="z-index: 99" class="mt-3 mt-sm-0 mb-3 mx-2 mb-sm-3">
      <label class=""><strong> Filter by Year & Month </strong></label>
      <br />
      <!-- <a-select
        v-model="selectedMonthFilter"
        style="width: 220px; z-index: 99"
        @change="() => getAllNews()"
        allowClear
      >
        <a-select-option
          v-for="(doctor, i) in months"
          :key="i"
          :value="String(i + 1).length > 1 ? `${i + 1}` : `0${i + 1}`"
        >
          {{ doctor }}
        </a-select-option>
      </a-select> -->

      <a-date-picker
        mode="month"
        v-model="value"
        @change="onDateValueChange"
        @panelChange="handlePanelChange2"
        @openChange="handleOpenChange"
        format="YYYY-MM"
        placeholder="Filter by year & month"
        ref="datePicker"
        :open="openDatePicker"
      >
        <template slot="renderExtraFooter">
          <a-button class="float-right my-2" @click="handleFilterMonth"
            >Filter</a-button
          >
        </template>
      </a-date-picker>
      <a-button class="ml-1" @click="handleResetDate" :disabled="!value"
        >See All</a-button
      >
      <br />

      <!-- <a-date-picker v-model="selectedMonthFilter" picker="month" /> -->
      <!-- <a-range-picker
        v-model="selectedMonthFilter"
        @change="handleRangePicker"
      /> -->
    </div>
    <div class="mb-4">
      <a-table
        :columns="columns"
        :dataSource="filteredItems"
        :pagination="true"
        :class="$style.table"
        rowKey="id"
        :loading="isLoading"
      >
        <template slot="judul" slot-scope="judul, record">
          <div>
            <div v-if="isAdmin">
              <router-link
                :to="{ path: '/artikel/details/' + record.id }"
                class="kit__utils__link font-size-16"
                >{{ record.title }}</router-link
              >
            </div>
            <div v-if="!isAdmin">{{ record.title }}</div>
            <div class="text-gray-4">
              <span v-for="tag in record.tags" :key="tag.id">
                {{ tag }}
              </span>
              <!-- {{record.tags.length > 0? record.tags: '-'}}</div> -->
            </div>
          </div>
        </template>
        <template slot="createdAt" slot-scope="createdAt">
          <div>
            <div>
              {{ createdAt ? moment(createdAt).format('DD MMM YYYY') : '-' }}
            </div>
          </div>
        </template>
        <template slot="body" slot-scope="body">
          <div>
            <div>{{ body ? body : '-' }}</div>
          </div>
        </template>
        <template slot="writer" slot-scope="writer">
          <div>
            <div>{{ writer ? writer : '-' }}</div>
          </div>
        </template>
        <template slot="tag" slot-scope="tag">
          <div>
            <div>{{ tag !== 'null' ? tag : 'Artikel Umum' }}</div>
          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import { getAll, getTotalViews } from '@/services/axios/api/artikel'
import moment from 'moment'
const columns = [
  {
    title: 'Judul Artikel',
    dataIndex: 'judul',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'judul' },
    sorter: (a, b) => {
      return a.title.localeCompare(b.title)
    },
  },
  {
    title: 'Tanggal Dibuat',
    dataIndex: 'createdAt',
    className: 'bg-transparent text-gray-6 width-50',
    scopedSlots: { customRender: 'createdAt' },
    sorter: (a, b) => {
      return a.createdAt.localeCompare(b.createdAt)
    },
  },
  {
    title: 'Penulis',
    dataIndex: 'writer',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'writer' },
    sorter: (a, b) => {
      return a.writer.localeCompare(b.writer)
    },
  },
  {
    title: 'Dilihat Sebanyak',
    dataIndex: 'total_views',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'total_views' },
    sorter: (a, b) => {
      return a.total_views - b.total_views > b.total_views - a.total_views
        ? -1
        : a.total_views - b.total_views < b.total_views - a.total_views
        ? 1
        : 0
    },
  },
  {
    title: 'Kategori',
    dataIndex: 'tag',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'tag' },
    onFilter: (value, record) => {
      return record.tag === value
    },
    filters: [
      {
        text: 'Artikel Umum',
        value: 'null',
      },
      {
        text: 'TAGRISSO',
        value: 'TAGRISSO',
      },
      {
        text: 'FASLODEX',
        value: 'FASLODEX',
      },
      {
        text: 'LYNPARZA',
        value: 'LYNPARZA',
      },
    ],
  },
  // {
  //   title: 'Isi Artikel',
  //   dataIndex: 'body',
  //   className: 'bg-transparent text-gray-6 width-50',
  //   scopedSlots: { customRender: 'body' },
  //   sorter: (a, b) => { return a.body.localeCompare(b.body) },
  // },
]

export default {
  name: 'TabelArtikel',
  data: function () {
    return {
      columns,
      items: [],
      filteredItems: [],
      months: [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember',
      ],
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      isLoading: false,
      isAdmin: false,
      selectedMonthFilter: undefined,
      date: null,
      value: null,
      openDatePicker: false,
    }
  },
  created() {
    this.getAllNews()
    this.getRole()
  },
  methods: {
    moment,
    async getAllNews() {
      this.isLoading = true
      const res = await getAll()
      // const monthsFilter = []
      for (const i in res) {
        const totalViews = await getTotalViews(
          res[i].id,
          this.value ? moment(this.value).format('YYYY/MM') : '',
        )
        res[i].total_views = totalViews.total
        res[i].tag = res[i].tag === null ? 'null' : res[i].tag
        const tags = []
        // console.log(res[i].tags)
        for (const j in res[i].tags) {
          tags.push(res[i].tags[j].tag)
        }

        res[i].tags = tags
      }
      this.items = res
      this.filteredItems = res.sort((a, b) =>
        a.total_views - b.total_views > b.total_views - a.total_views
          ? -1
          : a.total_views - b.total_views < b.total_views - a.total_views
          ? 1
          : 0,
      )
      this.$store.state.articleData = res
      this.isLoading = false
      // console.log(res, '<<<<<<<')
    },
    getRole() {
      const role = window.localStorage.getItem('role')
      // console.log(role)
      if (role === 'admin' || role === 'astrazeneca') {
        this.isAdmin = true
      }
    },
    handleRangePicker(e) {
      console.log(e)
    },
    onDateValueChange(val) {
      this.date = val
      this.value = val
      this.getAllNews()
    },
    handleResetDate() {
      this.date = null
      this.value = null
      this.getAllNews()
    },
    handlePanelChange2(value) {
      this.date = value
      this.value = moment(value._d)
    },
    handleFilterMonth() {
      this.openDatePicker = false
      this.getAllNews()
    },
    handleOpenChange(status) {
      this.openDatePicker = status
      this.value = moment()
    },
    // onFilter(items) {
    //   console.log(this.selectedMonthFilter, '<<<<< BEFORE')

    //   this.getAllNews(this.selectedMonthFilter)
    //   // this.filteredItems = items.filter((item) => {
    //   //   for (var key in filters) {
    //   //     if (
    //   //       !filters[key].includes(this.months[moment(item.createdAt).month()])
    //   //     ) {
    //   //       return false
    //   //     }
    //   //   }
    //   //   return true
    //   // })
    //   // console.log(this.filteredItems, '<<<<<< AFTER')
    // },
  },
}
</script>
<style lang="scss" module>
@import './style.module.scss';
</style>
